import { render, staticRenderFns } from "./NoMoney.vue?vue&type=template&id=361af75c&scoped=true&"
import script from "./NoMoney.vue?vue&type=script&lang=js&"
export * from "./NoMoney.vue?vue&type=script&lang=js&"
import style0 from "./NoMoney.vue?vue&type=style&index=0&id=361af75c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "361af75c",
  null
  
)

export default component.exports